<template>
    <div class="section-box">
        <el-table
        :data="tableData"
        style="width: 100%;margin-top: 20px;"
        height="740"
        border
        v-loading="listLoading" >
        <el-table-column
            prop="createTime"
            label="日期"
            width="220">
        </el-table-column>
        <el-table-column
            prop="code"
            label="code">
        </el-table-column>
        <el-table-column
            prop="name"
            label="名称">
            <template slot-scope="scope">
                <span>{{scope.row.name || '--'}}</span>
            </template>
        </el-table-column>
        <el-table-column
            prop="phone"
            label="联系方式">
        </el-table-column>
        <el-table-column
            prop="platform"
            label="渠道来源">
            <template slot-scope="scope">
                <span>{{scope.row.platform || '--'}}</span>
            </template>
        </el-table-column>
        <el-table-column
            prop="description"
            label="反馈内容"
            width="320">
            <template slot-scope="scope">
                <span>{{scope.row.description || '--'}}</span>
            </template>
        </el-table-column>
      </el-table>
      <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.pageNum"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        feedBackList, 
    } from "@/service/run";
    export default {
        data() {
            return {   
                listLoading: false,
                form: {
                    pageNum: 1,
                    pageSize: 10,
                }, 
                total: 0,//总条数
                tableData:[],
            };
        },
        created() {
            this.feedBackListFun();
        },
        methods: {
            //列表
            async feedBackListFun() {
                this.listLoading = true
                let res = await feedBackList(this.form);
                this.listLoading = false;
                if(res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.tableData = res.Data.datas;
                this.total = res.Data.total;
            },
            handleCurrentChange(val) {
                if (this.listLoading) return
                this.form.pageNum = val
                this.feedBackListFun()
            },
            //翻页
            handleSizeChange(val) {
                if (this.listLoading) return
                this.form.pageNum = 1
                this.form.pageSize = val
                this.feedBackListFun()
            },
        }
    }
</script>
<style>
.section-box {
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    min-height: 700px;
}
</style>